<template>
  <div class="pjmain">
    <div class="content" v-cloak>
      <van-tabs v-model="active" color="#00d2ff">
        <van-tab title="详情信息">
      <div class="pjxqtitle" v-if='bxxq'>
            <div class="sm-tit">报修人信息</div>
            <p><span>小区：</span>{{ bxxq.villageName }}</p>
            <p>  
              <span>楼栋号：</span>{{ bxxq.address.split(' ')[0]||'暂无' }}栋
            </p>
            <p><span>单元：</span>{{ bxxq.address.split(' ')[1]||'暂无' }}</p>
            <p><span>楼层：</span>{{ bxxq.address.split(' ')[2]||'暂无' }}</p>
            <p><span>门牌号：</span>{{ bxxq.address.split(' ')[2]||'暂无' }}</p>
            <p><span>业主名称：</span>{{ bxxq.houseOwnerName||'暂无' }}</p>
            <p><span>联系方式：</span>{{ bxxq.mobile||'暂无' }}</p>
            <div class="sm-tit" style="margin-top:20px">报修信息</div>
            <p><span>报修类型：</span>{{ bxxq.repairType||'暂无' }}</p>
            <p>
              <span>报修地址：</span>{{ bxxq.address.split(' ')[0] }}栋{{ bxxq.address.split(' ')[1] }}单元{{ bxxq.address.split(' ')[2] }}室
            </p>
            <p><span>报修人：</span>{{ bxxq.houseOwnerName||'暂无' }}</p>
            <p><span>报修人电话：</span>{{ bxxq.mobile||'暂无' }}</p>
            <p><span>报修内容：</span>{{ bxxq.repairDes||'暂无' }}</p>
      </div>
      <div class="pjxqtitle" v-else>
            <div class="sm-tit">报修人信息</div>
            <p><span>小区：</span>{{ bxxq.villageName }}</p>
            <p>  
              <span>楼栋号：</span>暂无
            </p>
            <p><span>单元：</span>暂无</p>
            <p><span>楼层：</span>暂无</p>
            <p><span>门牌号：</span>暂无</p>
            <p><span>业主名称：</span>{{ bxxq.houseOwnerName||'暂无' }}</p>
            <p><span>联系方式：</span>{{ bxxq.mobile||'暂无' }}</p>
            <div class="sm-tit" style="margin-top:20px">报修信息</div>
            <p><span>报修类型：</span>{{ bxxq.repairType||'暂无' }}</p>
            <p>
              <span>报修地址：</span>暂无
            </p>
            <p><span>报修人：</span>{{ bxxq.houseOwnerName||'暂无' }}</p>
            <p><span>报修人电话：</span>{{ bxxq.mobile||'暂无' }}</p>
            <p><span>报修内容：</span>{{ bxxq.repairDes||'暂无' }}</p>
      </div>


          <div class="sm-tit" v-show="type==2">
            
            <div class="bt md20">
              <button @click="add()" class="btn">派工</button>
            </div>
            <div class="bt md20">
              <button @click="add1()" class="btn" style="background-color:green">完工</button>
            </div>


          <div class="pj-dv">
            作废
            <van-cell-group>
              <van-field
                v-model="zfyy"
                label="作废原因"
                placeholder="请输入作废原因"
                input-align="right"
                required
                type="textarea"
              ></van-field>
            </van-cell-group>
            <div class="bt md20">
              <button @click="down()" class="btn" style="background: red">
                作废
              </button>
            </div>
          </div>

          </div>

          <div class="sm-tit" v-show="type==1">

          <div class="pj-dv">
            中断
            <van-cell-group>
              <van-field
                v-model="zdyy"
                label="中断原因"
                placeholder="请输入中断原因"
                input-align="right"
                required
                type="textarea"
              ></van-field>
            </van-cell-group>
            <div class="bt md20">
              <button @click="cut()" class="btn" style="background: orange">
                中断
              </button>
            </div>
          </div>
          </div>

          <div class="sm-tit" v-show="type==3">
            <div class="bt md20">
              <button @click="take()" class="btn">
                签收
              </button>
            </div>
          <div class="pj-dv">
            退回
            <van-cell-group>
              <van-field
                v-model="thyy"
                label="退回原因"
                placeholder="请输入退回原因"
                input-align="right"
                required
                type="textarea"
              ></van-field>
            </van-cell-group>
            <div class="bt md20">
              <button @click="back()" class="btn" style="background: red">
                退回
              </button>
            </div>
          </div>
          </div>

          <div class="sm-tit" v-show="type==4">
            <div class="bt md20">
              <button @click="done()" class="btn">
                完工
              </button>
            </div>
          </div>




        </van-tab>
        <van-tab title="办理跟踪">
          <van-steps direction="vertical" :active="lcno">
            <van-step v-for="(item,index) in lcList" :key='index'>
              <h3>{{item.currentActivitiName}}</h3>
              <p>{{item.operateName||'暂无'}}于{{item.lastModifiedDate}}{{item.action}}</p>
            </van-step>
          </van-steps>
        </van-tab>
      </van-tabs>

    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Image as VanImage, ImagePreview, Tab,Tabs,Step,Steps } from "vant";

Vue.use(VanImage);
Vue.use(ImagePreview);
Vue.use(Step);
Vue.use(Steps);
export default {
  data() {
    return {
      isPingjia: false,
      wg:false,
      nobtn:true,
      lcno:0,
      zfyy: "",
      active: 0,
      renyuan: [],
      lcList:[],
      showfl: false,
      levels: [
        { id: "0", value: "", text: "满意", title: "" },
        { id: "1", value: "", text: "不满意", title: "" },
      ],
      xzlist: {
        bmid: "",
        typetext: "",
        phone: "",
        bz: "",
      },
      zdyy:'',//中断原因
      thyy:'',//退回原因
      tsxq: {},
      bxxq: {address:'0 0 0 0 1',houseOwnerName:""},
      type: 1,
    };
  },
  mounted() {
    var id = this.$route.query.id;
    var type = this.$route.query.type || 1;
    this.type = type;
    this.wg = this.$route.query.wg;
    this.nobtn = this.$route.query.nobtn;
    this.getLiuch()

      this.$axios.get("/api/v1/repair/sys/" + id).then((res) => {
        this.bxxq = res;
      });
    
  },
  methods: {

    getLiuch() {
      var id = this.$route.query.id;
      this.$axios.get("/api/v1/repair/process/" + id).then((res) => {
      // console.log("🚀 ~ file: gddetail.vue:199 ~ this.$axios.get ~ res:", res)
      this.lcList=res
      this.lcno=res.length-1
      });
    },
    changeType(e) {
      console.log(e);
    },
    preview(imgarr) {
      var arr = imgarr.map((obj) => {
        return this.imgIp + obj;
      });
      ImagePreview({
        images: arr,
        onClose() {},
      });
    },
    add() {
      this.$router.push({ path: "/tsbx/bxpgdet", query: {id:this.$route.query.id} });

    },
    add1(){
      this.$router.push({ path: "/tsbx/bxwgdet", query: {id:this.$route.query.id,wg:true} });
    },
    down() {
      if (this.zfyy == "") {
        this.$dialog({ message: "请写明作废原因" });
        return;
      }
      var data = {
            repair:{
              id:this.$route.query.id
            },
            content:this.zfyy
          };
      this.$axios.post("/api/v1/repair/handler/rwzf", data).then((res) => {
        console.log(res);
        this.$dialog({ message: "提交成功" }).then(() => {
          this.$router.go(-1);
        });
      });
    },
    cut() {
      if (this.zdyy == "") {
        this.$dialog({ message: "请写明中断原因" });
        return;
      }
      var data = {
            repair:{
              id:this.$route.query.id
            },
            content:this.zdyy
          };
      this.$axios.post("/api/v1/repair/handler/rwzd", data).then((res) => {
        console.log(res);
        this.$dialog({ message: "提交成功" }).then(() => {
          this.$router.go(-1);
        });
      });
    },

        take() {
      var data = {
            repair:{
              id:this.$route.query.id
            }
          };
      this.$axios.post("/api/v1/repair/handler/rwqs", data).then((res) => {
        console.log(res);
        this.$dialog({ message: "提交成功" }).then(() => {
          this.$router.go(-1);
        });
      });
    },


    back() {
      if (this.thyy == "") {
        this.$dialog({ message: "请写明退回原因" });
        return;
      }
      var data = {
            repair:{
              id:this.$route.query.id
            },
            content:this.thyy
          };
      this.$axios.post("/api/v1/repair/handler/rwth", data).then((res) => {
        console.log(res);
        this.$dialog({ message: "提交成功" }).then(() => {
          this.$router.go(-1);
        });
      });
    },

  done(){
    this.$router.push({ path: "/tsbx/bxwgdet", query: {id:this.$route.query.id,wg:true} });
    // this.$router.push({ path: "/tsbx/bjxq", query: {id:this.$route.query.id,type:1,wg:true} });//进入投诉-工单办结-办结完工详情页
  }

  },
};
</script>
<style lang="less" scoped>
[v-cloak] {
  display: none;
}
.bt {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.md20 {
  margin-bottom: 20px;
}
.pjmain {
  height: calc(100% - 46px);
  width: 100%;
  background-color: #fff;
}
.shangchuan {
  line-height: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  box-sizing: border-box;
  width: 100%;
  padding: 10px 0px;
  overflow: hidden;
  color: #323233;
  font-size: 14px;
  line-height: 24px;
  border-bottom: #f4f4f4 1px solid;
  font-size: 16px;
}
.pj-dv {
  // border-top: 1px solid #f4f4f4;
  margin-top: 20px;
}
.mt10 {
  margin-top: 10px;
}
.sm-tit {
  color: #28aff6;
}
.btn {
  margin-top: 30px;
  outline: none;
  border: none;
  border-radius: 10px;
  color: white !important;
  font-weight: 600;
  background: #28aff6;
  height: 40px;
  width: 70%;
  cursor: pointer;
}
.content {
  height: 100%;
  width: 92%;
  margin: 0 4% 0 4%;
  .pjxqtitle {
    padding: 10px 0;
    font-size: 18px;
    border-bottom: #f4f4f4 1px solid;
    p {
      span {
        display: inline-block;
        color: #999999;
        width: 90px;
        text-align: left;
      }
      font-size: 14px;
      color: #000;
      margin: 0;
      line-height: 2rem;
    }
  }
  .bxqk {
    width: 100%;
    line-height: 25px;
    textarea {
      height: 125px;
      outline: none;
      border: #dddddd 1px solid;
      border-radius: 20px;
      margin-top: 10px;
      margin-bottom: 10px;
      text-indent: 2rem;
      color: #999999;
    }
    p {
      margin: 0;
      padding: 0;
    }
  }
}
.daxing {
  display: flex;
  align-items: center;
  span {
    margin-right: 10px;
  }
}
.tijiao {
  margin-top: 30px;
  margin-bottom: 30px;
  outline: none;
  border: none;
  border-radius: 10px;
  color: white;
  font-weight: 600;
  background: #28aff6;
  height: 40px;
  margin-left: 15%;
  width: 70%;
  cursor: pointer;
}
.dpj {
  height: 25px;
  top: calc(50% - 15px);
  border: 1px solid #00d2ff;
  color: #00d2ff;
  background-color: transparent;
  border-radius: 30px;
  font-size: 15px;
}
</style>